<template lang="pug">
	#root
		div#login(v-if="!user")
			.hero
				.hero-head
				.hero-body
					.container
						img.brand(src="/img/cp.png")
						h1.title CREW DISPATCH
						form
							.field
								input.input.is-large.is-fullwidth(v-model="pin", placeholder="Enter your PIN")
							div
								button(@click="login", type="button").button.is-primary.is-large.is-fullwidth Signin
				.hero-foot
		div(v-else-if = "!company") 
			.card
				.card-content.warning
					.hero.is-vcentered
						.hero-head
						.hero-body
							.container
								.title(style="color:black", v-html="no_company_heading")
								p(v-html="no_company_message")
		
		div(v-else).content
			//- Large Screen
			nav.flex.is-hidden-mobile
				.flex-min.padded: CompanyPicker
				.flex-min.padded: CrewPicker
				.flex-min.padded
					.control
						.select.is-fullwidth
							select(v-model="view")
									option(value="tasks") Tasks
									option(value="specials") Special Tasks
									option(value="members") Crew Members
									option(value="leaders") Crew Leaders
			//- Phone
			nav.is-hidden-tablet
				div(style="padding:0.5rem")
					CompanyPicker.is-fullwidth
				div(style="padding:0.5rem")
					CrewPicker.is-fullwidth
				div(style="padding:0.5rem")
					.control
						.select.is-fullwidth
							select(v-model="view")
									option(value="tasks") Tasks
									option(value="specials") Special Tasks
									option(value="members") Crew Members
									option(value="leaders") Crew Leaders
			div#app-content
				
							
					.card(v-if="view=='tasks'")
						.card-content
							p.title Tasks
							.columns
								.column
									.subtitle Assigned Tasks
									//-pre {{JSON.stringify(crew.dispatch, null, 2)}}
									section(v-if='crew && crew.dispatch')
										section.task(v-for='task in crew.dispatch.tasks.lineItems', :key='task._id')
											.flex
												.flex-grow
													TaskLabel(:task='task', category='line-item')
												.flex-min
													button.is-danger.button(@click='remove_task(task, "lineItems")')
														font-awesome-icon(icon='times') 
										section.task(v-for='task in crew.dispatch.tasks.equipment', :key='task._id')
											.flex
												.flex-grow
													TaskLabel(:task='task', category='equipment')
												.flex-min
													button.is-danger.button(@click='remove_task(task, "equipment")')
														font-awesome-icon(icon='times') 
											
										section.task(v-for='task in crew.dispatch.tasks.workorders', :key='task._id')
											.flex
												.flex-grow
													TaskLabel(:task='task', category='workorder')
												.flex-min
													button.is-danger.button(@click='remove_task(task, "workorder")')
														font-awesome-icon(icon='times') 
								.column
									.subtitle Available Tasks
									.field
										Lister(placeholder="Search by name/code", :pin='pin', :company='company', :crew='crew', url='tasks', mutation="tasks", fetch="tasks")
									section
										section.task(v-for='task in $store.state.tasks', :key='task._id')
											.flex
												.flex-min(style='padding-right:1rem')
													font-awesome-icon(icon='check', v-if='assigned(task)')
													button.is-info.button(v-else, @click='add_task(task)')
														font-awesome-icon(icon='plus') 
													
												.flex-grow
													TaskLabel(:task='task', :category='task.type')
					.card(v-if="view=='specials'")
						.card-content
							p.title Special Tasks
							.columns
								.column
									SpecialTask(label="Lunch", :task='crew.dispatch.lunch', @on='toggle_special("lunch", true)', @off='toggle_special("lunch", false)')
									SpecialTask(label="Breaks", :task='crew.dispatch.breaks', @on='toggle_special("breaks", true)', @off='toggle_special("breaks", false)')
									SpecialTask(label="Personal Time", :task='crew.dispatch.personal', @on='toggle_special("personal", true)', @off='toggle_special("personal", false)')
								.column
									SpecialTask(label="Travel", :task='crew.dispatch.travel', @on='toggle_special("travel", true)', @off='toggle_special("travel", false)')
									SpecialTask(label="General and Administrative", :task='crew.dispatch.ga', @on='toggle_special("ga", true)', @off='toggle_special("ga", false)')
												
					.card(v-if="view=='members'")
						.card-content
							p.title Members
							.columns
								.column
									.subtitle Current Members
									section.current_member(v-for='member in crew.members')
											.flex
												.flex-grow
													Employee(:employee='member')
												.flex-min
													button.is-danger.button(@click='remove_member(member)')
														font-awesome-icon(icon='times')
								.column
									.subtitle Available Employees
									.field
										Lister(placeholder="Search by name/code", :pin='pin', :company='company', :crew='crew', url='members/available', mutation="available_members", fetch="available_members")
									section
										.current_member(v-for='member in $store.state.available_members')
											.flex
												.flex-min(style="padding-right:1rem")
													button.is-info.button(@click='add_member(member)')
														font-awesome-icon(icon='plus')
												.flex-grow
													Employee(:employee='member')
												
					.card(v-if="view=='leaders'")
						.card-content
							p.title Leaders
							.columns
								.column
									.subtitle Current Leaders
									section.current_member(v-for='leader in crew.leads')
											.flex
												.flex-grow
													Employee(:employee='leader')
												.flex-min(v-if='leader._id != user._id')
													button.is-danger.button(@click='remove_leader(leader)')
														font-awesome-icon(icon='times') 
								.column
									.subtitle Available Foreman
										.field
											Lister(placeholder="Search by name/code", :pin='pin', :company='company', :crew='crew', url='leaders/available', mutation="available_leaders", fetch="available_leaders")
									section
										.current_member(v-for='leader in $store.state.available_leaders')
											.flex
												.flex-min(style="padding-right:1rem")
													button.is-info.button(@click='add_leader(leader)')
														font-awesome-icon(icon='plus')
												.flex-grow
													Employee(:employee='leader')
												
		footer.footer(v-if="user")
			.flex
				.flex-min(style="padding-right:1rem")
					button.button.is-success.is-large(@click='refresh')
						font-awesome-icon(icon='sync')
				.flex-min(style="padding-right:1rem")
					ClearPin
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import ClearPin from "@/components/ClearPin";
import CompanyPicker from "@/components/CompanyPicker";
import CrewPicker from "@/components/CrewPicker";
import Employee from "@/components/Employee";
import PinService from "@/api/pin";
import CrewService from "@/api/crew";
import Lister from "@/components/Lister";
import SpecialTask from "@/components/SpecialTask";
import TaskLabel from "@/components/TaskLabel";
import moment from "moment";

export default {
  name: "crew-dispatch",
  data: function() {
    return {
      pin: null,
      view: "tasks"
    };
  },
  components: {
    ClearPin,
    CompanyPicker,
    CrewPicker,
    Employee,
    Lister,
    SpecialTask,
    TaskLabel
  },
  computed: {
    ...mapState(["user", "crew", "company", "companies"]),
    ...mapGetters([]),
    no_company_heading() {
      return "No Access";
    },
    no_company_message() {
      return "You must be a <b> foreman</b> to use the app.";
    }
  },
  mounted: function() {
    this.$store.state.bus.$on("crew", async () => {
      const membership = await CrewService.fetch(
        this.pin,
        this.company,
        this.crew
      );
      this.$store.commit("membership", membership);
    });
    this.$store.subscribe((mutation, state) => {
      if (!state.user) {
        // Logged out, do nothing with local storage, as it shoudl have already been cleared.
        localStorage.clear();
        return;
      }

      // Store the serializable state in local storage in case page refresh
      // in offline environment.
      const serializable = {
        user: state.user,
        company: state.company,
        crew: state.crew,
        crews: state.crew,
        companies: state.companies,
        view: this.view
      };

      localStorage.setItem(
        `crew-state-${this.pin}`,
        JSON.stringify(serializable)
      );
    });

    const stored_pin = localStorage.getItem("crew-pin");
    if (stored_pin) this.pin = stored_pin;
    if (this.pin) {
      this.login();
    }
  },
  methods: {
    moment: function() {
      return moment();
    },
    assigned(task) {
      if (this.crew && this.crew.dispatch) {
        const i = this.crew.dispatch.tasks.lineItems
          .map(t => t._id)
          .indexOf(task._id);
        const j = this.crew.dispatch.tasks.equipment
          .map(t => t._id)
          .indexOf(task._id);
        const k = this.crew.dispatch.tasks.workorders
          .map(t => t._id)
          .indexOf(task._id);
        return i + j + k > -3;
      } else {
        return false;
      }
    },
    async add_task(task) {
      let prop;
      switch (task.type) {
        case "line-item":
          prop = "lineItems";
          break;
        case "equipment":
          prop = "equipment";
          break;
        case "workorder":
          prop = "workorders";
          break;
      }
      this.crew.dispatch.tasks[prop].push(task);
      await CrewService.save_dispatch(
        this.pin,
        this.company,
        this.crew,
        this.crew.dispatch
      );
    },
    async remove_task(task, prop) {
      this.crew.dispatch.tasks[prop] = this.crew.dispatch.tasks[prop].filter(
        function(t) {
          return t._id != task._id;
        }
      );
      await CrewService.save_dispatch(
        this.pin,
        this.company,
        this.crew,
        this.crew.dispatch
      );
    },
    async toggle_special(prop, value) {
      this.crew.dispatch[prop] = value;
      // Save this to back end.
      await CrewService.save_dispatch(
        this.pin,
        this.company,
        this.crew,
        this.crew.dispatch
      );
    },
    async remove_leader(leader) {
      this.crew.leads = this.crew.leads.filter(m => m._id != leader._id);
      await CrewService.leads(
        this.pin,
        this.company,
        this.crew,
        this.crew.leads
      );
      this.$store.state.bus.$emit("available_leaders");
    },
    async remove_member(member) {
      this.crew.members = this.crew.members.filter(m => m._id != member._id);
      await CrewService.members(
        this.pin,
        this.company,
        this.crew,
        this.crew.members
      );
      this.$store.state.bus.$emit("available_members");
    },
    async add_leader(leader) {
      this.crew.leads.push(leader);
      await CrewService.leads(
        this.pin,
        this.company,
        this.crew,
        this.crew.leads
      );
      this.$store.state.bus.$emit("available_leaders");
    },
    async add_member(member) {
      this.crew.members.push(member);
      await CrewService.members(
        this.pin,
        this.company,
        this.crew,
        this.crew.members
      );
      this.$store.state.bus.$emit("available_members");
    },
    refresh: async function() {
      const response = await PinService.login(this.pin);
      this.$store.commit("refresh", response.data);
      //await this.load_times();
    },
    login: async function() {
      localStorage.setItem("crew-pin", this.pin);
      const stored = localStorage.getItem(`crew-state-${this.pin}`);
      let stored_company = null;
      let stored_crew = null;

      if (stored) {
        const stored_object = JSON.parse(stored);

        if (stored_object.company) {
          stored_company = stored_object.company;
        }
        if (stored_object.crew) {
          stored_crew = stored_object.crew;
        }
      }

      try {
        const response = await PinService.login(this.pin);
        this.$store.commit("login", response.data);
      } catch (ex) {
        this.offline = true;

        // Load Vuex from local storage, as long as this is the same pin
        const stored = localStorage.getItem(`crew-state-${this.pin}`);
        if (stored) {
          this.$store.commit("load", JSON.parse(stored));
        }
      }
      // Restore user selections from last load.
      if (stored_company) {
        // If the user was working on a company before, restore it - as long as it is still
        // in the company list.
        const i = this.$store.state.companies
          .map(c => c._id)
          .indexOf(stored_company._id);
        if (i >= 0) {
          this.$store.commit("company", stored_company);
        }
      }

      if (stored_crew) {
        // If the user was working on a crew before, restore it - as long as it is still
        // in the crew list.
        const i = this.$store.state.crews
          .map(c => c._id)
          .indexOf(stored_crew._id);
        if (i >= 0) {
          this.$store.commit("crew", stored_crew);
        }
      }
    }
  }
};
</script>

<style lang="less">
#login {
  background-color: #4d8298 !important;
  height: 100vh;
}

img.brand {
  width: 50%;
  margin-left: auto;
  margin-right: auto;
}
nav {
  background-color: #333;
  margin-bottom: 0px !important;
}
#login h1 {
  color: white !important;
}
section {
  text-align: left;
}
.flex {
  display: flex;
}
.flex-min {
  flex-grow: 0;
}
.flex-shrink {
  flex-shrink: 2;
}
.flex-grow {
  flex-grow: 10;
}

#crew-sticky {
  position: sticky;
  top: 0;
  z-index: 1000;
}
.html {
  background-color: #2c3e50 !important;
}
.card-content {
  text-align: left;
}

.footer {
  padding: 0.5rem !important;
  bottom: 0px;
  .button {
    margin-bottom: 0.5rem;
  }
}
.card {
  background-color: #2c3e50 !important;
  .title,
  .subtitle {
    color: white;
  }
}

.task,
.current_member {
  border: thin #dddddd solid;
  margin-bottom: 1rem;
  padding: 1rem;
  background-color: #efefef;
}
</style>
